// @flow

import type { DefaultStandardScriptsState } from "./types";

export const initialState: DefaultStandardScriptsState = {
  requestsInProgress: 0,
  list: null,
  current: null,
  draft: null,
  modals: {
    showEditModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showDiscardModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
